import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllThemes(oauthTokenHeader: string, website_shared_uid: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/design/themes/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader
  );
}

function createTheme(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/design/themes/`,
    data,
    oauthTokenHeader
  );
}

function getSingleTheme(oauthTokenHeader: string, theme_shared_uid: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/design/themes/${theme_shared_uid}/`,
    oauthTokenHeader
  );
}

function editTheme(
  oauthTokenHeader: string,
  data: any,
  theme_shared_uid: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/design/themes/${theme_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function requestTheme(oauthTokenHeader: any, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/tasks/`,
    data,
    oauthTokenHeader
  );
}

function fileUploadME(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getFiles(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function getWidgetStructure(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/meta/widgets_structure`, oauthTokenHeader);
  }

export const themeService = {
  getAllThemes,
  createTheme,
  getSingleTheme,
  editTheme,
  requestTheme,
  fileUploadME,
  getFiles,
  getWidgetStructure
};